import { render } from "./chindArticleCompile.vue?vue&type=template&id=2a7424ef&scoped=true"
import script from "./chindArticleCompile.vue?vue&type=script&lang=js"
export * from "./chindArticleCompile.vue?vue&type=script&lang=js"

import "../forum/css/antd.css?vue&type=style&index=0&lang=css"
import "./chindArticleCompile.vue?vue&type=style&index=1&id=2a7424ef&lang=css"
import "./chindArticleCompile.vue?vue&type=style&index=2&id=2a7424ef&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7424ef"]])

export default __exports__